<template>
  <v-container text-xs-center style="max-height: 40vh; max-width: 1054px">
    <v-layout row wrap>
      <v-toolbar color="white" class="elevation-0" height="30">
        <v-layout>
          <v-expand-transition class>
            <div
              xs12
              sm3
              xl4
              v-show="selected.length > 0"
              style="margin-left: 30px; margin-top: 9px"
            >
              <v-expand-transition>
                <v-btn
                  flat
                  @click="editStd"
                  fab
                  small
                  v-show="selected.length <= 1 && selected.length > 0"
                  v-if="permits['UPDATE_STUDENTS']"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-expand-transition>
              <v-btn
                flat
                fab
                small
                @click="deleteStd"
                v-if="permits['DELETE_STUDENTS']"
              >
                <v-icon color="primary">delete</v-icon>
              </v-btn>
            </div>
          </v-expand-transition>
        </v-layout>
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip
              right
              v-if="permits['ADD_STUDENTS'] || permits['LINK_STUDENTS_PARENTS']"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="permits['ADD_STUDENTS']"
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  small
                  fab
                  v-on="on"
                  @click="addStd"
                >
                  <v-icon>add</v-icon>
                  <v-icon>add</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  small
                  fab
                  v-on="on"
                >
                  <v-icon>add</v-icon>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span v-if="permits['ADD_STUDENTS']">
                {{ $t('parents.table_tutors.create_student') }}
              </span>
              <span v-else>
                {{ $t('parents.table_tutors.options') }}
              </span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="linkStd"
              v-if="permits['LINK_STUDENTS_PARENTS']"
            >
              <v-icon>link</v-icon>
            </v-btn>
            <span>
              {{ $t('parents.table_tutors.students_to_be_linked') }}
            </span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container style="max-height: 30vh" class="scrollDesign">
        <v-layout row wrap>
          <v-flex ma-1 xs12 class="expandableContainer">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="students"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              select-all
              no-data-text="No tiene tutorados"
              :class="'tabledata'"
              style="max-height: 18vh; overflow-y: scroll"
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                      v-if="permits['DELETE_STUDENTS']"
                    ></v-checkbox>
                  </th>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    {{ $t('parents.table_tutors.photo') }}
                  </th>
                  <th style="width: 200px; max-width: 200px; min-width: 200px">
                    {{ $t('parents.table_tutors.first_name') }}
                  </th>
                  <th style="width: 200px; max-width: 200px; min-width: 200px">
                    {{ $t('parents.table_tutors.last_name') }}
                  </th>
                  <th style="width: 200px; max-width: 200px; min-width: 200px">
                    {{ $t('parents.table_tutors.level') }}
                  </th>
                  <th style="width: 200px; max-width: 200px; min-width: 200px">
                    {{ $t('parents.table_tutors.group') }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td style="width: 78px; max-width: 78px; min-width: 78px">
                  <v-checkbox
                    color="primary"
                    v-if="
                      permits['DELETE_STUDENTS'] || permits['UPDATE_STUDENTS']
                    "
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td style="width: 78px; max-width: 78px; min-width: 78px">
                  <v-avatar :tile="tile" :size="avatarSize">
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        :src="props.item.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon
                      v-else
                      :color="props.item.gender == 'MALE' ? 'blue' : 'pink'"
                      >account_circle</v-icon
                    >
                  </v-avatar>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{ props.item.firstName }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{ props.item.lastName }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{ props.item.level.typeLevel }}
                  </CustomTooltipOverflowText>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <CustomTooltipOverflowText>
                    {{
                      props.item.gradeGroup.grade + props.item.gradeGroup.group
                    }}
                  </CustomTooltipOverflowText>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <confirm
          :class="!confirm.value ? 'position-no' : ''"
          :value="confirm.value"
          :title="confirm.title"
          :description="confirm.description"
          v-on:desition="desitionDelete"
        ></confirm>

        <StudentModal
          :class="!modals.student ? 'position-no' : ''"
          :title="modals.title"
          :parent="parentId"
          :value="modals.value"
          :student="select.student"
          v-on:created="stdCreated"
          v-on:updated="stdUpdated"
          v-on:input="closeModal"
          v-model="modals.student"
        ></StudentModal>

        <LinkStudent
          :class="!modals.LinkV ? 'position-no' : ''"
          :title="modals.title"
          :parent="parentId"
          :parentName="parentName"
          :value="modals.LinkV"
          v-on:linked="stdLinked"
          v-on:close="closeModalLink"
          v-model="modals.LinkV"
        ></LinkStudent>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import confirm from '../../Dialogs/Confirm.vue'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import LinkStudent from '../../Modals/LinkStudentModal.vue'
import StudentModal from '../../Modals/StudentModal.vue'
import CustomTooltipOverflowText from '../../generic/custom_tooltip_overflow_text.vue'

export default {
  components: {
    CustomTooltipOverflowText,
    confirm,
    StudentModal,
    LinkStudent,
    loading,
    success,
    error,
  },
  props: ['students', 'parentName', 'parentId', 'permits'],
  data: () => ({
    headers: [
      {
        text: 'Foto',
        value: 'gender',
      },

      {
        text: 'Nombre',
        align: 'left',
        value: 'firstname',
      },
      {
        text: 'Apellidos',
        value: 'lastName',
      },
      {
        text: 'Nivel',
        value: 'level',
      },
      {
        text: 'Grado y grupo',
        value: 'gg',
      },
    ],
    selected: [],
    select: {
      student: null,
    },
    working: {
      wLoading: false,
    },
    loading: false,
    avatarSize: '30px',
    tile: false,
    modals: {
      title: '',
      student: false,
      import: false,
      value: false,
      LinkV: false,
    },
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    avatarSize: '30px',
    tile: false,
    gotImages: 0,
    toast: {
      success: false,
      failed: false,
    },
    imgKey: 0,
  }),
  created() {},
  mounted() {},
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.students.slice()
    },
    stdCreated(event) {
      this.toast.success = true
      event.image = 'data:image/jpeg;base64,' + event.image
      this.students.unshift(event)
    },
    stdUpdated(event) {
      this.toast.success = true
      this.students.splice(this.students.indexOf(this.select.student), 1, event)
      //this.getImagesForStd(event.id)
      this.select.student = null
      this.selected = []
    },
    stdLinked(event) {
      this.toast.success = true
      this.students.unshift(event)
    },
    closeModalLink(event) {
      this.modals.LinkV = event
    },
    addStd(event = null) {
      this.select.student = null
      this.modals.title = this.$t('parents.table_tutors.create_student')
      this.modals.student = true
    },
    linkStd(event = null) {
      this.modals.title = this.$t('parents.table_tutors.add_student_to_tutor')
      this.modals.LinkV = true
    },
    editStd() {
      this.select.student = this.selected[0]
      this.modals.student = true
      this.modals.title = this.$t('parents.table_tutors.edit_student')
    },
    deleteStd() {
      this.confirm.description =
        'Esta a punto de desligar a ' +
        (this.selected.length == 1
          ? 'a ' + this.selected[0].firstName + ' ' + this.selected[0].lastName
          : this.selected.length + ' alumnos del padre.\n') +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
      this.confirm.value = true
    },
    desitionDelete(e) {
      if (e) {
        this.deleteStudents()
      } else {
        this.confirm.value = false
      }
    },

    deleteStudents() {
      this.working.wLoading = true
      if (this.selected.length > 0) {
        for (var i in this.selected) {
          this.sendUnLinkStudentRequest(i)
        }
      }
    },

    sendUnLinkStudentRequest(i) {
      this.$store
        .dispatch('tutor/removeChildToParents', {
          sid: this.selected[i].id,
          pars: [{ id: this.parentId }],
        })
        .then((response) => {
          this.students.splice(this.students.indexOf(this.selected[i]), 1)

          this.working.wLoading = false
          this.toast.success = true
          this.confirm.value = false
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.error = true
          console.log(error)
        })
    },
    closeModal(event) {
      this.modals.student = false
    },
    closeLinkModal(e) {
      this.modals.LinkV = false
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      ;(this.modals.student = false),
        (this.modals.import = false),
        (this.modals.value = false),
        (this.modals.LinkV = false)
      this.$forceUpdate()
    },
    toggleBodyClass(className) {
      const el = document.body
      // debugger;
      el.classList.remove(className)
      // .v-btn__content
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
}
</script>
<style scoped>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
td,
th {
  width: 295px;
  max-width: 295px;
  min-width: 295px;
}
/deep/ .v-datatable.v-table > tbody {
  max-height: 7vh;
  min-height: 7vh;
}
.v-btn--floating.v-btn--small .v-icon {
  width: 40px !important;
}
</style>
<style scoped>
::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
}
</style>
